module.exports = __webpack_public_path__ + "static/media/fleet-efficiency-inactive.e973bbfa.svg";